import jQuery from 'jquery';

(function ( $ ) {
	function closeAccordionPanel( $title ) {
		const $slide = $title.closest( '.accordion--card' ).find( '.accordion--slide' );
		const $inner = $slide.find( '.accordion--slide__inner' );

		$inner.slideUp( function () {
			$slide.hide();
		} );
		$title.addClass( 'down' ).removeClass( 'up' );
	}

	function openAccordionPanel( $title ) {
		const $slide = $title.closest( '.accordion--card' ).find( '.accordion--slide' );
		const $inner = $slide.find( '.accordion--slide__inner' );

		$slide.show();
		$inner.slideDown();
		$title.addClass( 'up' ).removeClass( 'down' );
	}

	// Accordion toggle (news page + home/projekt list view)
	$( document ).on( 'click', '.accordion--simple .click--down', function () {
		const $viewRoot = $( this ).closest( '.home-start' );
		if ( $viewRoot.length && $viewRoot.attr( 'data-view' ) !== 'list' ) {
			return;
		}

		const $title = $( this );

		if ( $title.hasClass( 'down' ) ) {
			openAccordionPanel( $title );
		} else {
			closeAccordionPanel( $title );
		}
	} );

	// Grid / list view toggle (home + projekte; mobile toolbar lives in header)
	function setHomeStartView( view ) {
		if ( ! view ) {
			return;
		}

		const $homeStarts = $( '.home-start' );
		if ( ! $homeStarts.length ) {
			return;
		}

		$homeStarts.attr( 'data-view', view );
		$( '.home-start__view-btn' ).each( function () {
			const $btn     = $( this );
			const isActive = $btn.data( 'view' ) === view;
			$btn.toggleClass( 'is-active', isActive );
			$btn.attr( 'aria-pressed', isActive ? 'true' : 'false' );
		} );

		$( '.home-start__view-toggle' ).each( function () {
			const $toggle   = $( this );
			const gridLabel = $toggle.data( 'label-grid' ) || 'Rasteransicht';
			const listLabel = $toggle.data( 'label-list' ) || 'Listenansicht';

			$toggle.attr( 'data-active-view', view );
			$toggle.attr( 'aria-pressed', view === 'list' ? 'true' : 'false' );
			$toggle.attr( 'aria-label', view === 'grid' ? listLabel : gridLabel );
		} );

		$( '.home-start__toolbar--desktop' ).removeClass( 'is-list-hover' );

		if ( view === 'grid' ) {
			$homeStarts.find( '.click--down.up' ).each( function () {
				closeAccordionPanel( $( this ) );
			} );
		}

		$homeStarts.trigger( 'home-start:viewchange' );
	}

	$( document ).on( 'click', '.home-start__view-btn', function () {
		setHomeStartView( $( this ).data( 'view' ) );
	} );

	$( document ).on( 'click', '.home-start__view-toggle', function () {
		const $homeStarts = $( '.home-start' );
		if ( ! $homeStarts.length ) {
			return;
		}

		const currentView = $homeStarts.first().attr( 'data-view' ) || 'grid';
		setHomeStartView( currentView === 'grid' ? 'list' : 'grid' );
	} );

	// Desktop toolbar: hover list (when inactive) → grid previews inactive state
	$( document ).on( 'mouseenter', '.home-start__toolbar--desktop .home-start__view-btn[data-view="list"]:not(.is-active)', function () {
		$( this ).closest( '.home-start__toolbar--desktop' ).addClass( 'is-list-hover' );
	} );

	$( document ).on( 'mouseleave', '.home-start__toolbar--desktop .home-start__view-btn[data-view="list"]:not(.is-active)', function () {
		$( this ).closest( '.home-start__toolbar--desktop' ).removeClass( 'is-list-hover' );
	} );

	$( document ).on( 'mouseleave', '.home-start__toolbar--desktop', function () {
		$( this ).removeClass( 'is-list-hover' );
	} );
})( jQuery );
